import { FormControl, FormControlLabel, Radio, RadioGroup, Box, TextField } from '@mui/material'
import capitalize from 'lodash/capitalize'
import styled from 'styled-components'

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0;
  padding: 10px 16px;
  border: 2px solid ${(props) => (props.checked ? '#6779e3' : '#e2e8f0')};
  border-radius: 10px;
  background: ${(props) => (props.checked ? 'rgba(103, 121, 227, 0.08)' : '#ffffff')};
  transition: all 0.2s ease;
  min-width: 120px;
  justify-content: center;

  &:hover {
    border-color: #6779e3;
    background: rgba(103, 121, 227, 0.04);
  }

  .MuiRadio-root {
    color: #94a3b8;
    padding: 4px 8px;

    &.Mui-checked {
      color: #6779e3;
    }
  }

  .MuiFormControlLabel-label {
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => (props.checked ? '#1e293b' : '#64748b')};
    margin-left: 8px;
  }
`

const AdditionalInputContainer = styled(Box)`
  margin-top: 16px;
  padding: 16px;
  background: rgba(103, 121, 227, 0.04);
  border: 2px solid rgba(103, 121, 227, 0.2);
  border-radius: 12px;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: #6779e3;
    box-shadow: 0 0 0 3px rgba(103, 121, 227, 0.1);
  }
`

const StyledTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
    background: #ffffff;
    transition: all 0.2s ease;

    &:hover {
      border-color: #6779e3;
    }

    &.Mui-focused {
      border-color: #6779e3;
      box-shadow: 0 0 0 3px rgba(103, 121, 227, 0.1);
    }
  }

  .MuiOutlinedInput-input {
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.5;
  }
`

export default function ScreeningSingleChoiceWithDescription({ question, answer, onChange }) {
  const choices = question?.choices || ['Yes (हाँ)', 'No (नहीं)']
  const additionalInputArr = Object.entries(question?.requiresAdditionalInput || {})

  const handleRadioChange = (e) => {
    const value = e.target.value
    onChange({
      ...answer,
      response: value,
      additionalResponse: '',
    })
  }

  const showAdditionalInput = additionalInputArr.some(
    ([key, value]) => value && key.toLowerCase() === answer?.response?.toLowerCase(),
  )

  return (
    <Box>
      <FormControl component="fieldset" fullWidth>
        <StyledRadioGroup
          value={answer?.response || ''}
          onChange={handleRadioChange}
          row
        >
          {choices.map((choice) => (
            <StyledFormControlLabel
              key={choice}
              value={choice}
              control={<Radio />}
              label={capitalize(choice)}
              checked={answer?.response === choice}
            />
          ))}
        </StyledRadioGroup>
      </FormControl>
      {showAdditionalInput && (
        <AdditionalInputContainer>
          <StyledTextField
            multiline
            rows={3}
            value={answer?.additionalResponse || ''}
            onChange={(e) => onChange({ ...answer, additionalResponse: e.target.value })}
            placeholder="Enter additional information..."
            variant="outlined"
            fullWidth
          />
        </AdditionalInputContainer>
      )}
    </Box>
  )
}
